import { all, call, put, takeLatest } from 'redux-saga/effects';
import axiosInstance, { AxiosPost } from '../../../utils/axios';
import { getFbTrackingPayload } from '../../../utils/fbTracking';
import * as actions from './actions';

function* createPending(action) {
  try {
    const { email, name, features, handImage } = action.payload;
    let result;
    if (handImage) {
      // Con foto → multipart para subir la imagen de la mano. Header por-request
      // (no vía BearerConfig, que solo lo pone si hay sesión; el funnel es anónimo).
      const fd = new FormData();
      fd.append('email', email || '');
      if (name) fd.append('name', name);
      if (features) fd.append('features', JSON.stringify(features));
      fd.append('hand_image', handImage);
      result = yield call(
        [axiosInstance, axiosInstance.post],
        `/quiromancia/create_pending_reading/`,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );
    } else {
      result = yield call(AxiosPost, `/quiromancia/create_pending_reading/`, { email, name, features });
    }
    yield put(actions.createPendingSuccess(result.data.reading_id));
  } catch (e) {
    yield put(actions.createPendingFailure(e));
  }
}

function* checkout(action) {
  try {
    const result = yield call(AxiosPost, `/quiromancia/create_checkout/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.quiromanciaCheckoutSuccess());
    window.location.href = result.data.checkout_url;
  } catch (e) {
    yield put(actions.quiromanciaCheckoutFailure(e));
  }
}

function* paypalOrder(action) {
  try {
    const result = yield call(AxiosPost, `/quiromancia/create_paypal_order/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.quiromanciaPaypalOrderSuccess());
    window.location.href = result.data.approve_url;
  } catch (e) {
    yield put(actions.quiromanciaPaypalOrderFailure(e));
  }
}

function* verify(action) {
  try {
    const result = yield call(AxiosPost, `/quiromancia/verify_purchase/`, action.payload);
    yield put(actions.quiromanciaVerifyPurchaseSuccess(result.data));
  } catch (e) {
    yield put(actions.quiromanciaVerifyPurchaseFailure(e));
  }
}

function* verifyPaypal(action) {
  try {
    const result = yield call(AxiosPost, `/quiromancia/verify_paypal_purchase/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.quiromanciaVerifyPaypalSuccess(result.data));
  } catch (e) {
    yield put(actions.quiromanciaVerifyPaypalFailure(e));
  }
}

export default function* quiromanciaSaga() {
  yield all([
    takeLatest(actions.CREATE_PENDING_REQUEST, createPending),
    takeLatest(actions.CHECKOUT_REQUEST, checkout),
    takeLatest(actions.PAYPAL_REQUEST, paypalOrder),
    takeLatest(actions.VERIFY_REQUEST, verify),
    takeLatest(actions.VERIFY_PAYPAL_REQUEST, verifyPaypal),
  ]);
}
